import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal, LinkedInputGroup, LinkedInput } from 'components/basic'
import { Installation } from 'config'
import { date, notify, Translate } from 'helpers'
import http from 'API/http'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'

class Subscriptions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      subscriptions:  null,
      deactivationDate: null,
      selectedService: {},
      accessId: ''
    }
  }
  componentDidMount () {
    this.setSubscriptions(this.props.services, this.props.accessId)
  }
  componentWillReceiveProps(props) {
    if (props.updated === this.props.updated) return false
    this.setSubscriptions(props.services, props.accessId)
  }
  setSubscriptions(subscriptions, accessId) {
    this.setState({subscriptions, accessId})
  }
  editReference (service) {
    this.setState({serviceToEdit: service, editModal: true})
  }
  async deactivateService () {
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      operation: 'DEACTIVATE',
      requestedDateTime: (!this.state.deactivationDate ? null : this.state.deactivationDate.unix())
    })
    if (err) return notify.alert('', res.cause, 'error')
    this.setState({deactivateModal: false})
    notify.alert('', 'The service will be deactivated ' + (!this.state.deactivationDate ? 'soon.' : moment(this.state.deactivationDate).format('YYYY-MM-DD')), 'success')
    this.props.callback()
  }
  async modifyService () {
    var [err, res] = await http.post('2.4/orders', {
      accessId: this.state.accessId,
      service: this.state.selectedService.service,
      subscriptionId: this.state.selectedService.subscriptionId,
      spSubscriptionId: this.state.selectedService.spSubscriptionId,
      spReference: this.state.selectedService.spReference,
      operation: 'MODIFY',
    })
    if (err) return notify.alert('', res.message, 'error')
    this.setState({editModal: false})
    notify.alert('', 'References has been updated!', 'success')
    this.props.callback()
  }
  static isDateValid (current) {
    var yesterday = Datetime.moment().subtract(1, 'day')
    return current.isAfter(yesterday)
  }
  render () {
    if (!this.state.subscriptions) return false
    return (
      <div>
      <StaticBox cols={12} icon='cog' title={Translate({'SE': 'Tjänster', 'EN': 'Subscriptions'})}>
        <FlowTable data={this.state.subscriptions.map(subscription => [
          <a onClick={e => this.setState({selectModal: true, selectedService: subscription})} className='table-link'><i className='fa fa-edit' /></a>,
          subscription.service,
          <span>{subscription.spReference}</span>,
          <span>{subscription.spSubscriptionId}</span>,
          subscription.option82,
          (!subscription.activationDate ? '' : moment(subscription.activationDate).format('YYYY-MM-DD HH:mm:ss')),
          subscription.deactivationDate ? moment(subscription.activationDate).format('YYYY-MM-DD HH:mm:ss') : '',
          (Installation.enable.tickets && Installation.enable.ticketsCreate) ?
            <a onClick={e => (window.location = ('/#/ticket/wizard/' + this.state.accessId + '/' + window.btoa(subscription.service)))} className='table-link'><i className='fa fa-plus' /></a> :
            (!Installation.enable.ticketsCreate) ? <a onClick={e => this.setState({ticketModal: true})} className='table-link'><i className='fa fa-plus' /></a> : <i className='fa fa-ban text-muted' />])}>
          <tr>
            <th className='buttons' />
            <th>Service</th>
            <th>Your Internal Reference</th>
            <th>Subscription  Reference</th>
            <th>Option 82</th>
            <th>Activation Date</th>
            <th>Deactivation Date</th>
            <th className={(!Installation.enable.tickets ? 'text-muted' : '')}>Trouble Ticket</th>
          </tr>
        </FlowTable>
      </StaticBox>
      <Modal noOverflow title={this.state.selectedService.service} isOpen={this.state.selectModal} close={e => this.setState({selectModal: false})}>
        <div className='col-md-9 col-md-push-1 selection-buttons-wrapper'>
          <div className='selection-buttons'>
            <a className='selection-button' onClick={() => this.setState({deactivateModal: true, selectModal: false})}><i className='fa fa-fw fa-times' /> Deactivate <i className='fa fa-fw fa-arrow-right' /></a>
            <a className='hidden selection-button'><i className='fa fa-fw fa-ban' /> Suspend <i className='fa fa-fw fa-arrow-right' /></a>
            <a className='hidden selection-button'><i className='fa fa-fw fa-forward' /> Resume <i className='fa fa-fw fa-arrow-right' /></a>
            <a className='selection-button' onClick={() => this.setState({editModal: true, selectModal: false})}><i className='fa fa-fw fa-edit' /> Edit Parameters <i className='fa fa-fw fa-arrow-right' /></a>
            <a className='hidden selection-button'><i className='fa fa-fw fa-cog' /> Change Service <i className='fa fa-fw fa-arrow-right' /></a>
          </div>
        </div>
      </Modal>
      <Modal noOverflow title={this.state.selectedService.service} isOpen={this.state.deactivateModal} close={e => this.setState({deactivateModal: false})} buttons={[
          { text: 'Cancel', event: e => this.setState({deactivateModal: false, selectedService: {}}) },
          { text: 'Disconnect', event: e => this.deactivateService() }
      ]}>
        <label>Deactivation time</label>
        <Datetime isValidDate={this.isDateValid} value={this.state.deactivationDate} onChange={date => {
          this.setState({deactivationDate: date})
        }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
          <div className='input-group'>
            <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
            <input {...props} className='form-control' />
          </div>
        } />
      </Modal>
      <Modal title={'Edit references for ' + this.state.selectedService.service} noOverflow isOpen={this.state.editModal} close={e => this.setState({editModal: false})} buttons={[
          { text: 'Cancel', event: e => this.setState({editModal: false, selectedService: {}}) },
          { text: 'Save', event: e => this.modifyService() }
      ]}>
        <LinkedInputGroup ref={(form) => { this.editForm = form }}>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>Your Internal Reference</label>
              <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='selectedService.spReference' />
            </div>
            <div className='form-group col-md-12'>
              <label>Subscription Reference</label>
              <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='selectedService.spSubscriptionId' />
            </div>
          </div>
        </LinkedInputGroup>
      </Modal>
    </div>
    )
  }
}
export default Subscriptions



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/access/Subscriptions.js